module.exports = __webpack_public_path__ + "static/media/blood5.78b76fd5.svg";